import type {
    AudioLiveStreamChannels,
    Episode,
    Guest,
} from "@foundation/live-schedule";

export interface LiveRadioEpisode {
    episodeInfo: Required<Episode>;
    episodeGuests: Required<Guest>[];
}

export async function fetchLiveRadioScheduleFromApi(
    channel: AudioLiveStreamChannels,
    signal?: AbortSignal
): Promise<LiveRadioEpisode[]> {
    try {
        const showsResponse = await fetch(
            `/lineup-next/api/live-schedule?channel=${channel}`,
            {
                signal,
            }
        );

        return showsResponse.json();
    } catch (error) {
        throw new Error(
            `Error when fetching from api/live-schedule?channel=${channel}: ${error}`
        );
    }
}
